import { render, staticRenderFns } from "./funding.vue?vue&type=template&id=f16cee82"
import script from "./funding.vue?vue&type=script&lang=js"
export * from "./funding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports